import { memo, useCallback } from 'react'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { CtaBar } from 'modules/cta-bar'
import { Layout } from 'modules/layout'
import { buildSimulatorUrl } from 'src/utils/buildSimulatorUrl'
import { pushDataLayer } from 'utils/push-data-layer'

import Hero from './hero'

const Benefits = dynamic(() => import('./benefits'))
const BetterOption = dynamic(() => import('./better-option'))
const Description = dynamic(() => import('./description'))
const Eligibility = dynamic(() => import('./eligibility'))
const Feedbacks = dynamic(() => import('modules/feedbacks'))
const Help = dynamic(() => import('./help'))
const HowWorks = dynamic(() => import('./how-works'))
const Tips = dynamic(() => import('./tips'))

const DebtPortability = memo(() => {
  const router = useRouter()

  const handleClick = useCallback(
    (clickTarget: string, label: string) => {
      pushDataLayer({
        category: 'Clique',
        action: 'Botões',
        label: `${clickTarget} - Empréstimo para Negativado - ${label}`
      })

      location.href = buildSimulatorUrl(router.pathname, { medium: clickTarget + '-' + label })
    },
    [router.pathname]
  )

  return (
    <Layout hasCTA>
      <Hero onClick={() => handleClick('Banner', 'Simular agora')} />
      <Benefits />
      <Eligibility onClick={() => handleClick('Elegibilidade', 'Simular agora')} />
      <HowWorks onClick={() => handleClick('Como solicitar', 'Simular agora')} />
      <BetterOption onClick={() => handleClick('Melhor opção', 'Simular agora')} />
      <Description onClick={() => handleClick('Como funciona', 'Simular agora')} />
      <Tips />
      <Feedbacks />
      <Help />
      <CtaBar
        title="Simule agora o seu empréstimo"
        buttonLabel="Simular agora"
        onClick={() => handleClick('Flutuante', 'Simular agora')}
      />
    </Layout>
  )
})

DebtPortability.displayName = 'DebtPortability'

export default DebtPortability
